export {
    Slug as default,
    getServerSidePropsOfSlug as getServerSideProps,
} from '../compositions';
